export class CustomerNotesSearchItem {
  public CustomerId: number;
  public StartDate: Date;
  public EndDate: Date;
  public StartDateCheck: boolean;
  public EndDateCheck: boolean;

  constructor(startDate: Date, endDate: Date) {
    this.StartDate = startDate;
    this.EndDate = endDate;
    this.StartDateCheck = false;
    this.EndDateCheck = false;
  }
}

export class CustomerNotesViewModel {
  public Id: number;
  public Note: string;
  public CreatedUserId: number;
  public CreatedUserName: string;
  public CreatedDated: string;
  public AddressToCustomerId: number;
  public AddressToCustomerName: number;
}
